<app-breadcrumb [title]="'Hallazgos de la Inspección'" [items]="['Pesv', 'Zonas de vías', 'Inspecciones']"
  [active_item]="inspeccionActual?.codigo || 'Hallazgos de vías'"></app-breadcrumb>

<div class="container-fluid">
  <div class="card">
    <div class="card-header d-flex align-items-center justify-content-between bg-primary text-white">
      <div class="d-flex align-items-center">
        <i class="fa fa-exclamation-triangle me-2"></i>
        <h5 class="mb-0"><strong>HALLAZGOS DE LA INSPECCIÓN {{ inspeccionActual?.codigo }} - ZONA {{ zonaActual?.codigo }} {{ zonaActual?.nombre }}</strong></h5>
      </div>
      <button type="button" class="btn btn-light btn-sm" (click)="volver()">
        <i class="fa fa-arrow-left me-1"></i>Volver a inspecciones
      </button>
    </div>

    <div class="card-body">
      <ul class="nav nav-tabs mb-4">
        <li class="nav-item">
          <button type="button" class="nav-link" [class.active]="activeTab === 1" (click)="activeTab = 1">
            <i class="fa fa-plus me-1"></i>{{ editando ? 'Editar hallazgo' : 'Registrar hallazgo' }}
          </button>
        </li>
        <li class="nav-item">
          <button type="button" class="nav-link" [class.active]="activeTab === 2" (click)="mostrarListado()">
            <i class="fa fa-list me-1"></i>Listado de hallazgos
          </button>
        </li>
      </ul>

      <form *ngIf="activeTab === 1" [formGroup]="form" (ngSubmit)="guardar()">
        <!-- 1. Información general -->
        <div class="panel-section mb-4">
          <div class="panel-title">
            <i class="fa fa-info-circle me-2"></i>
            1. Información general
          </div>

          <div class="row g-3 mt-2">
            <div class="col-md-4">
              <label class="form-label">Zona:</label>
              <input type="text" class="form-control" [value]="zonaActual?.codigo + ' - ' + zonaActual?.nombre" readonly />
            </div>

            <div class="col-md-4">
              <label class="form-label">Inspección:</label>
              <input type="text" class="form-control" [value]="inspeccionActual?.codigo" readonly />
            </div>

            <div class="col-md-4">
              <label class="form-label">Riesgo asociado: <span class="text-dark">(Opcional)</span></label>
              <ng-select [items]="riesgosDeZona" bindLabel="codigo" bindValue="id" placeholder="Seleccione un riesgo de la zona"
                formControlName="riesgo_id" [clearable]="true" notFoundText="La zona no tiene riesgos registrados">
              </ng-select>
            </div>

            <div class="col-md-3">
              <label class="form-label required">Código: <span class="text-danger">*</span></label>
              <input type="text" class="form-control" formControlName="codigo" placeholder="HAL-001" />
            </div>

            <div class="col-md-3">
              <label class="form-label required">Fecha de detección: <span class="text-danger">*</span></label>
              <input type="date" class="form-control" formControlName="fecha_deteccion" />
            </div>

            <div class="col-md-6">
              <label class="form-label required">Tipo de hallazgo: <span class="text-danger">*</span></label>
              <ng-select [items]="tiposHallazgo" bindLabel="descripcion" bindValue="id" placeholder="Seleccione un tipo"
                formControlName="tipo_hallazgo" [clearable]="true" [searchable]="false">
              </ng-select>
            </div>

            <div class="col-md-12">
              <label class="form-label required">Descripción: <span class="text-danger">*</span></label>
              <textarea class="form-control" rows="3" formControlName="descripcion"
                placeholder="Describa el hallazgo identificado"></textarea>
            </div>
          </div>
        </div>

        <!-- 2. Análisis del hallazgo -->
        <div class="panel-section mb-4">
          <div class="panel-title">
            <i class="fa fa-search me-2"></i>
            2. Análisis del hallazgo
          </div>

          <div class="row g-3 mt-2">
            <div class="col-md-4">
              <label class="form-label">Condición encontrada: <span class="text-dark">(Opcional)</span></label>
              <textarea class="form-control" rows="3" formControlName="condicion_encontrada"></textarea>
            </div>

            <div class="col-md-4">
              <label class="form-label">Causa: <span class="text-dark">(Opcional)</span></label>
              <textarea class="form-control" rows="3" formControlName="causa"></textarea>
            </div>

            <div class="col-md-4">
              <label class="form-label">Consecuencia: <span class="text-dark">(Opcional)</span></label>
              <textarea class="form-control" rows="3" formControlName="consecuencia"></textarea>
            </div>
          </div>
        </div>

        <!-- 3. Valoración del riesgo -->
        <div class="panel-section mb-4">
          <div class="panel-title">
            <i class="fa fa-tachometer me-2"></i>
            3. Valoración del riesgo
          </div>

          <div class="row g-3 mt-2">
            <div class="col-md-3">
              <label class="form-label">Probabilidad: <span class="text-dark">(Opcional)</span></label>
              <ng-select [items]="escalaNivel" bindLabel="descripcion" bindValue="id" placeholder="Seleccione"
                formControlName="probabilidad" [clearable]="true" [searchable]="false">
              </ng-select>
            </div>

            <div class="col-md-3">
              <label class="form-label">Consecuencia: <span class="text-dark">(Opcional)</span></label>
              <ng-select [items]="escalaNivel" bindLabel="descripcion" bindValue="id" placeholder="Seleccione"
                formControlName="consecuencia_nivel" [clearable]="true" [searchable]="false">
              </ng-select>
            </div>

            <div class="col-md-3">
              <label class="form-label">Nivel de riesgo (automático):</label>
              <input type="text" class="form-control" readonly
                [value]="form.get('nivel_riesgo')?.value ? nombreNivel(form.get('nivel_riesgo')?.value) + ' (' + puntajeRiesgo + ')' : ''" />
            </div>

            <div class="col-md-3">
              <label class="form-label">Prioridad: <span class="text-dark">(Opcional)</span></label>
              <ng-select [items]="prioridades" bindLabel="descripcion" bindValue="id" placeholder="Seleccione una prioridad"
                formControlName="prioridad" [clearable]="true" [searchable]="false">
              </ng-select>
            </div>
          </div>
        </div>

        <!-- 4. Gestión -->
        <div class="panel-section mb-4">
          <div class="panel-title">
            <i class="fa fa-check-square-o me-2"></i>
            4. Gestión del hallazgo
          </div>

          <div class="row g-3 mt-2">
            <div class="col-md-4">
              <label class="form-label d-block">¿Requiere acción?</label>
              <div class="form-check form-switch">
                <input class="form-check-input" type="checkbox" id="requiereAccion" formControlName="requiere_accion" />
                <label class="form-check-label" for="requiereAccion">
                  {{ form.get('requiere_accion')?.value ? 'Sí, requiere acción' : 'No requiere acción' }}
                </label>
              </div>
            </div>

            <div class="col-md-4" *ngIf="form.get('requiere_accion')?.value">
              <label class="form-label required">Fecha de compromiso: <span class="text-danger">*</span></label>
              <input type="date" class="form-control" formControlName="fecha_compromiso"
                [min]="form.get('fecha_deteccion')?.value" />
            </div>

            <div class="col-md-12">
              <label class="form-label">Observaciones: <span class="text-dark">(Opcional)</span></label>
              <textarea class="form-control" rows="3" formControlName="observaciones"></textarea>
            </div>
          </div>
        </div>

        <div class="d-flex justify-content-between align-items-center mt-4 flex-wrap gap-3">
          <div class="d-flex gap-2">
            <button type="button" class="btn btn-light border text-secondary px-4"
              (click)="cancelar()">Cancelar</button>

            <button type="submit" class="btn btn-primary px-4" [disabled]="guardando">{{ guardando ? 'Guardando...' :
              'Guardar' }}</button>
          </div>
        </div>
      </form>

      <div *ngIf="activeTab === 2">
        <div class="row mb-3 align-items-center">
          <div class="col-md-4">
            <input type="search" class="form-control" [(ngModel)]="filtro" (input)="aplicarFiltro()"
              placeholder="Buscar por código, tipo, descripción o causa..." />
          </div>
        </div>

        <div *ngIf="cargandoListado" class="text-center py-4">
          <span class="spinner-border text-primary"></span>
          <p class="mt-2 mb-0">Cargando hallazgos...</p>
        </div>

        <div *ngIf="!cargandoListado" class="table-responsive">
          <table id="tblViasHallazgos" class="table table-bordered table-hover align-middle">
            <thead class="bg-primary text-white">
              <tr>
                <th class="text-center">CÓDIGO</th>
                <th class="text-center">TIPO</th>
                <th class="text-center">DESCRIPCIÓN</th>
                <th class="text-center">NIVEL DE RIESGO</th>
                <th class="text-center">PRIORIDAD</th>
                <th class="text-center">REQUIERE ACCIÓN</th>
                <th class="text-center">FECHA DETECCIÓN</th>
                <th class="text-center">FECHA COMPROMISO</th>
                <th class="text-center">ESTADO</th>
                <th class="text-center">ACCIONES</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let hallazgo of hallazgosFiltrados | paginate: { itemsPerPage: pageSize, currentPage: page }">
                <td class="text-center">{{ hallazgo.codigo }}</td>
                <td class="text-center">{{ nombreTipo(hallazgo.tipo_hallazgo) }}</td>
                <td>{{ hallazgo.descripcion }}</td>
                <td class="text-center">{{ hallazgo.NivelRiesgoData?.descripcion }}</td>
                <td class="text-center">
                  <span *ngIf="hallazgo.prioridad" class="badge" [ngClass]="clasePrioridad(hallazgo.prioridad)">
                    {{ nombrePrioridad(hallazgo.prioridad) }}
                  </span>
                </td>
                <td class="text-center">
                  <span class="badge" [ngClass]="hallazgo.requiere_accion ? 'bg-danger' : 'bg-secondary'">
                    {{ hallazgo.requiere_accion ? 'SÍ' : 'NO' }}
                  </span>
                </td>
                <td class="text-center">{{ formatearFecha(hallazgo.fecha_deteccion) }}</td>
                <td class="text-center">{{ formatearFecha(hallazgo.fecha_compromiso) }}</td>
                <td class="text-center">
                  <span class="badge" [ngClass]="Number(hallazgo.estado) === 1 ? 'bg-success' : 'bg-secondary'">
                    {{ Number(hallazgo.estado) === 1 ? 'ACTIVO' : 'INACTIVO' }}
                  </span>
                </td>
                <td class="text-center">
                  <button type="button" class="btn btn-sm btn-outline-primary me-1 rounded-pill btn-rounded"
                    (click)="editarHallazgo(hallazgo)" [disabled]="Number(hallazgo.estado) !== 1" title="Editar">
                    <i class="fa fa-pencil"></i>
                  </button>
                  <button type="button" class="btn btn-sm me-1 rounded-pill btn-rounded"
                    [ngClass]="Number(hallazgo.estado) === 1 ? 'btn-outline-danger' : 'btn-outline-success'"
                    (click)="cambiarEstado(hallazgo)" [title]="Number(hallazgo.estado) === 1 ? 'Inactivar' : 'Activar'">
                    <i class="fa" [ngClass]="Number(hallazgo.estado) === 1 ? 'fa-ban' : 'fa-check'"></i>
                  </button>
                </td>
              </tr>
              <tr *ngIf="!hallazgosFiltrados.length">
                <td colspan="10" class="text-center text-primary py-4">No hay hallazgos registrados.</td>
              </tr>
            </tbody>
          </table>
        </div>

        <div class="d-flex justify-content-between align-items-center mt-4" *ngIf="hallazgosFiltrados.length > 0">
          <div class="d-flex align-items-center">
            <label class="me-2">Mostrar:</label>
            <select class="form-select w-auto" [(ngModel)]="pageSize" (change)="page = 1">
              <option *ngFor="let size of [5, 10, 20, 50, 100]" [value]="size">{{ size }}</option>
            </select>
            <span class="ms-2">registros por página</span>
          </div>
          <div class="text-center flex-grow-1">
            Total Registros: <a class="badge badge-primary"><b>{{ hallazgosFiltrados?.length || 0 }}</b></a>
          </div>
          <div class="text-end paginador-personalizado">
            <pagination-controls (pageChange)="page = $event" [maxSize]="5" [directionLinks]="true"
              [autoHide]="true" previousLabel="Anterior" nextLabel="Siguiente"></pagination-controls>
          </div>
        </div>

        <div class="btn-showcase text-center mt-4" *ngIf="hallazgosFiltrados.length">
          <button type="button" class="btn btn-outline-success-2x me-2" (click)="exportarExcel()">
            <i class="icofont icofont-file-excel"></i> EXCEL
          </button>
          <button type="button" class="btn btn-outline-danger-2x" (click)="exportarPdf()">
            <i class="icofont icofont-file-pdf"></i> PDF
          </button>
        </div>
      </div>
    </div>
  </div>
</div>